export default {
  queryTagMap: {
    0: {},
    1: {
      minNotAssignTagCount: 1
    },
    2: {
      minNotAssignTagCount: 0,
      maxNotAssignTagCount: 0
    }
  },
  querySetMap: {
    0: {},
    1: {
      isPreassign: 0,
      minNotAssignSetCount: 1
    },
    2: {
      minNotAssignSetCount: 0,
      maxNotAssignSetCount: 0
    }
  },
  tags: [
    {
      value: 2,
      label: '涂层标签'
    },
    {
      value: 3,
      label: '芯片标签'
    },
    {
      value: 4,
      label: '普通标签'
    }
  ]
}
